import { render } from "./NavigationBarProp.vue?vue&type=template&id=36f26452&scoped=true"
import script from "./NavigationBarProp.vue?vue&type=script&lang=js"
export * from "./NavigationBarProp.vue?vue&type=script&lang=js"

import "./NavigationBarProp.vue?vue&type=style&index=0&id=36f26452&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f26452"]])

export default __exports__